import noop from 'lodash/noop';
import status from '~/status.json';

const initialState = {
  version: status.version,
};

const reducer = noop;

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/meta/reducer.js